import * as routeHelpers from "./routeHelpers";
import some from "lodash.some";

const UNAUTH_ROUTES = [
	routeHelpers.dev(),
	routeHelpers.error(),
	routeHelpers.forgotPassword(),
	routeHelpers.freeTrial(),
	routeHelpers.login(),
	routeHelpers.newGroup(),
	routeHelpers.newGroupSubmissionConfirmation(),
	routeHelpers.newGroupUser(),
	routeHelpers.newIndividualUser(),
	routeHelpers.newUnlimitedGroupUser(),
	routeHelpers.notFound(),
	routeHelpers.requestAccess(),
	routeHelpers.resetPassword(),
	routeHelpers.unauthorized(),
];

export default function isUnauthenticatedRoute(path) {
	if (path === "" || path === "/") {
		return false;
	}

	return some(UNAUTH_ROUTES, route => route.indexOf(path) === 0);
}
